export default __webpack_public_path__ + "static/media/barangBekas.312fd56b.jpg";